import { ISODateStringToUTCDate } from './ISODateStringToUTCDate';

export const isBefore = (dateString: string, compareDateString: string) => {
  const date = ISODateStringToUTCDate(dateString);
  const compareDate = ISODateStringToUTCDate(compareDateString);
  return date < compareDate;
};
